import { render, staticRenderFns } from "./speak-config.vue?vue&type=template&id=50ecaf36"
import script from "./speak-config.vue?vue&type=script&lang=js"
export * from "./speak-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports